export default __webpack_public_path__ + "media/images/icons/paperclip-solid-8d140ed223c7f2641fbdd1430006e6e4.svg";